import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  HttpErrorHandlerService,
  HandleError,
} from '../config/http-error-handler.service';
import { BaseSvcService } from '../config/base-svc.service';
import { AppOfflineStore } from '../../app.offlineService';
import { HttpRequest, HttpEvent } from '@angular/common/http';
import { SessionService } from '../session.service';
import { IStudyUnitDisplayOrder } from 'src/app/Component/content-management/study-unit-display-order/study-unit-display-order.component';
import { IGetCodes } from 'src/app/interfaces/codes';
import { Toast, ToastrService } from 'ngx-toastr';

export interface ICoursePlanPayload {
  LoggedInUser?: string; // Represents the logged-in user's ID (VARCHAR(20))
  CourseID: number; // Represents the course ID (BIGINT)
  CoursePlanID?: number | null; // Optional, represents the course plan ID (INTEGER)
  ScreenName: string; // Represents the screen name (VARCHAR(20))
  StudentID?: number | null; // Optional, represents the student ID (BIGINT)
}
export interface IGetCourseStudyUnitSubjectToSelect {
  Subject_ID: number;
  Subject_Name: string;
  Subject_Level_Type_Code: string;
  Subject_Level_Number: number;
  Parent_subject_ID: number;
  Selected_Ind: string;
}
export interface GetStudyUnitListparam {
  Subject_ID: number;
  Course_Id?: number;
  Study_Unit_Id?: number;
  Study_Unit_Status_Type_Code?: string;
  LoggedInUserID?: string;
  sessionLanguageTypeCode?: string;
  ErrorMessage?: string;
}
export interface UpdateStudyUnitDisplayOrderParams {
  LoggedInUser?: string;
  CourseID?: number;
  UDTStudyUnitDisplayOrder: UDTStudyUnitDisplayOrderParams[];
  ErrorMessage?: string;
  SuccessIND?: string;
}
export interface UDTStudyUnitDisplayOrderParams {
  StudyUnitID: number;
  DisplayOrder: number;
}
export interface IGetStudyUnitToCloneParams {
  LoggedInUser?: string;
  FromCourseID: number;
  ToCourseID: number;
  SubjectID: number | string;
}

export interface IPerformStudyMaterialCloningParams {
  LoggedInUser?: string;
  SessionLanguageTypeCode?: string;
  FromCourseID: number;
  FromStudyUnitID: number;
  ToCourseID: number;
  ToStudyUnitID: number | null;
}

export interface IStudyUnitToCloneItem {
  Major_Topic_ID?: number;
  Major_Topic_Name?: string;
  From_Study_Unit_ID?: number;
  From_Study_Unit_Name?: string;
  To_Study_Unit_ID?: number;
  To_Study_Unit_Name?: string;
  Display_Order?: number;
}
export interface ICreateUpdateStudyUnitPayload {
  Study_Unit_Name: string;
  Description_Text: string;
  SubjectId: number;
  Study_Unit_Id: number;
  Study_Unit_Status_Type_Code: string;
  Course_Id: number;
  LoggedInUserID?: string;
  sessionLanguageTypeCode?: string;
  ErrorMessage?: string;
}

export interface IStudyUnitPracticeQuestionCountRequest {
  LoggedInUser?: string;
  CourseID: number;
  SubjectID: number;
}
export interface ICourseMainTopicPayload {
  LoggedInUser?: string
  SubjectID: any
  CourseID: any
  CourseMainTopicID: number | null
  CourseMainTopicStatusTypeCode: any
  MajorTopicID: any
}

export interface ICourseMainTopic {
  Subject_ID: number
  Subject_Name: string
  Course_Main_Topic_Subject_Id: number
  Course_Main_Topic_Id: number
  Course_Main_Topic_Name: string
  Course_Main_Topic_Status_Type_Code: any
  Course_Main_Topic_Status_Type_Name: any
  Display_Order: number
  Exam_agency_ID: number
  Deleted_Ind:string
  Exam_agency_Name: string
  Course_ID: number
  Course_Name: string
  Exam_Short_Name: string
  Exam_Year: string
  Major_Topic_Name:string
  Major_Topic_ID:number
}


export interface InsertOrUpdateCourseMainTopicPayload {
  LoggedInUser?: string
  CourseMainTopicID: number | null
  SubjectID: number | null
  CourseID: number
  CourseMainTopicName: string | null
  CourseMainTopicStatusTypeCode: string | null
  DisplayOrder: number
  NewCourseMainTopicID: any
}

export interface UpdateCourseMainTopicDisplayOrderPayload {
  LoggedInUser?: string
  CourseID: number
  UDTCourseMainTopicDisplayOrder: UdtcourseMainTopicDisplayOrder[]
}

export interface UdtcourseMainTopicDisplayOrder {
  CourseMainTopicID: number
  DisplayOrder: number
  DeletedInd: string
}



@Injectable({
  providedIn: 'root',
})
export class ContentManagementService {
  private handleError: HandleError;
  public url: string;
  public options;
  private queryParamsSource = new BehaviorSubject<any>(null); // BehaviorSubject with default empty object
  queryParams$ = this.queryParamsSource.asObservable(); // Observable for subscribers

  setQueryParams(params: any): void {
    this.queryParamsSource.next(params); // Update the subject with new params
  }

  getQueryParams(): any {
    return this.queryParamsSource.getValue(); // Get the current value
  }
  constructor(
    private http: HttpClient,
    public session: SessionService,
    private appserv: AppOfflineStore,
    public httpErrorHandler: HttpErrorHandlerService,
    private config: BaseSvcService,

  ) {
    this.handleError = httpErrorHandler.createHandleError('HeroesService');
    this.url = this.config.activeURL;
    this.options = this.config._httpoption;
  }

  getStudyUnitsDisplayOrder(
    params: GetStudyUnitListparam
  ): Observable<IStudyUnitDisplayOrder[]> {
    params.LoggedInUserID = this.session.getUser();
    params.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(`${this.url}api/GetStudyUnitForDisplayOrder`, params)
      .pipe(map((e) => e.ResultList));
  }

  GetStudyUnitToClone(
    params: IGetStudyUnitToCloneParams
  ): Observable<IStudyUnitToCloneItem[]> {
    params.LoggedInUser = this.session.getUser();

    return this.http
      .post<any>(`${this.url}api/GetStudyUnitForCloning`, params, this.options)
      .pipe(map((res) => (res?.status ? res.data ?? [] : [])));
  }

  PerformStudyMaterialCloning(
    params: IPerformStudyMaterialCloningParams
  ): Observable<any> {
    params.LoggedInUser = this.session.getUser();
    params.SessionLanguageTypeCode = this.appserv.userlanuage;

    return this.http
      .post<any>(`${this.url}api/PerformStudyMaterialCloning`, params, this.options)
      .pipe(map((res) => (res?.status ? res.data ?? res : res)));
  }

getCourseMainTopicDisplayOrder(
  params: ICourseMainTopicPayload
): Observable<any[]> {
  params.LoggedInUser = this.session.getUser();

  return this.http
    .post<any>(`${this.url}api/GetCourseMainTopic`, params)
    .pipe(
      map((res) => {
        if (res?.status === true) {
          return res.data ?? [];
        }

        // Throw an error if API returns status = false
        // this.toaster.error(res.message,'Error',{timeOut:2500})
      })
    );
}

  InsertOrUpdateCourseMainTopic(
    params: InsertOrUpdateCourseMainTopicPayload
  ): Observable<any[]> {
    params.LoggedInUser = this.session.getUser();
    return this.http
      .post<any>(`${this.url}api/InsertOrUpdateCourseMainTopic`, params)
      .pipe(map((e) => e.data));
  }
  UpdateCourseMainTopicDisplayOrder(
    params: UpdateCourseMainTopicDisplayOrderPayload
  ): Observable<any[]> {
    params.LoggedInUser = this.session.getUser();
    return this.http
      .post<any>(`${this.url}api/UpdateCourseMainTopicDisplayOrder`, params)
      .pipe(map((e) => e.data));
  }
  getCourseMainStatusType(
  ): Observable<any[]> {
    return this.http
      .get<any>(`${this.url}api/GetCodes/COURSE_MAIN_TOPIC_STATUS_TYPE`)
      .pipe(map((e) => e.resultList));
  }

  updateStudyUnitDisplayOrder(
    params: UpdateStudyUnitDisplayOrderParams
  ): Observable<any> {
    params.LoggedInUser = this.session.getUser();
    params.ErrorMessage = '';
    params.SuccessIND = '';
    return this.http.post<any>(
      `${this.url}api/UpdateStudyUnitDisplayOrder`,
      params
    );
  }
  GetCourseStudyUnitSubjectToSelect$<T>(
    calledFrom: string | null,
    courseId: number | string,
    studyUnitId?: number | null
  ) {
    const payload = {
      LoggedInUser: this.session.getUser(),
      CalledFrom: calledFrom,
      CourseID: courseId,
      StudyUnitID: studyUnitId,
    };

    return this.http
      .post<T>(`${this.url}api/GetCourseStudyUnitSubjectToSelect`, payload)
      .pipe(map((res: any) => res.StudyMaterial ?? []));
  }

  getSubjectTree(data: any): Observable<any[]> {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http

      .post<any>(this.url + 'api/GetSubjectTreeNodes', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetCode<T>(data: { Tablename: string }): Observable<IGetCodes[]> {
    return this.http
      .get<{ resultList: IGetCodes[] }>(
        `${this.url}api/GetCodes/${data.Tablename}`,
        this.options
      )
      .pipe(
        map((response) => response.resultList),
        catchError(this.handleError<IGetCodes[]>('getQuestion', []))
      );
  }

  getCoursePlan$<T>(
    loggedInUser: string,
    courseId: number,
    coursePlanId: number | string,
    screenName: string,
    studentId: number | string,
    studyMaterialId: number | string
  ) {
    return this.http.get<T>(
      `${this.url}api/GetCoursePlan?LoggedInUser=${loggedInUser}&CourseID=${courseId}&CoursePlanID=${coursePlanId}&ScreenName=${screenName}&StudentID=${studentId}&StudyMaterialID=${studyMaterialId}`
    );
  }

  getsubjectById(data: any) {
    let request: any = {
      CurrentNodeSubjectID: Number(data.CurrentNodeSubjectID),
      LoggedInUserID: this.session.getUser(),
      sessionLanguageTypeCode: this.appserv.userlanuage,
    };
    return this.http
      .post<any>(this.url + 'api/GetSubjectByID', request, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetStudyMaterialList(data: any) {
    data.LoggedInUser = this.session.getUser();
    data.SessionLanguageTypeCode = this.appserv.userlanuage;
    data.StudyMaterialID = null;
    return this.http
      .post<any>(this.url + 'api/GetStudyMaterial', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetStudyUnitPracticeQuestionCount(
    payload: IStudyUnitPracticeQuestionCountRequest
  ): Observable<any[]> {
    payload.LoggedInUser = this.session.getUser();
    return this.http
      .post<any>(
        this.url + 'api/GetStudyUnitReadynessReport',
        payload,
        this.options
      )
      .pipe(map((res) => (res?.status ? res.data ?? [] : [])));
  }

  GetStudyUnit$(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(this.url + 'api/GetStudyUnit', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  getExamAgencyList<T>(loggedInUserID: string) {
    const data = {
      LoggedInUserId: loggedInUserID,
      ExamAgencyId: null,
    };
    return this.http.get<T>(
      `${this.url}api/GetExamAgency?LoggedInUserId=${loggedInUserID}&ExamAgencyId=${data.ExamAgencyId}`
    );
  }

  CreateOrModifyStudyUnit(data: ICreateUpdateStudyUnitPayload) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    data.ErrorMessage = '';
    return this.http
      .post<any>(this.url + 'api/InsertOrUpdateStudyUnit', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetStudyUnitSubject(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post(this.url + 'api/GetStudyUnitSubject', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  CreateOrModifyStudyUnitSubject(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    data.ErrorMessage = '';
    return this.http
      .post(this.url + 'api/InsertOrUpdateStudyUnitSubject', data, this.options)

      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetStudyMaterial(data: any) {
    data.LoggedInUser = this.session.getUser();
    data.SessionLanguageTypeCode = this.appserv.userlanuage;
    data.ScreenName = 'STUDY_MATERIAL';
    return this.http
      .post(this.url + 'api/GetStudyMaterial', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  getDropdownListByCode(code: string): Observable<IGetCodes[]> {
    return this.http
      .get<{ resultList: IGetCodes[] }>(`${this.url}api/GetCodes/${code}`)
      .pipe(map((response) => response.resultList));
  }

  CreateOrModifyStudyMaterial(fd: FormData | any) {
    fd.append('LoggedInUser', this.session.getUser());
    fd.append('SessionLanguageTypeCode', this.appserv.userlanuage);
    fd.append('ErrorMessage', '');
    return this.http.post(this.url + 'api/InsertOrUpdateStudyMaterial', fd);
  }

  upload(file: File, data: any): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    const req = new HttpRequest(
      'POST',
      `${this.url}/api/FileAPI/UploadFiles/` +
        data.StudymaterialId +
        '/' +
        data.filetype,
      formData,
      {
        reportProgress: true,
        responseType: 'json',
      }
    );
    return this.http.request(req);
  }

  GetContentStatusByID(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post(this.url + 'api/GetStudyMaterialStatusByID', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  CreateOrModifyStudyMaterialStatus(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    data.ErrorMessage = '';
    return this.http
      .post(
        this.url + 'api/InsertOrUpdateStudyMaterialStatus',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  getDuplicateNameValidation(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(this.url + 'api/GetCheckDuplicate', data, this.options)

      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  getBreadcrumb(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any[]>(this.url + 'api/GetPath', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetActivityHistory(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any[]>(
        this.url + 'api/GetStudyMaterialActivityHistory',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  GetStatusList(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any[]>(
        this.url + 'api/GetStudyMaterialStatusList',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetStudyMaterialReport(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any[]>(
        this.url + 'api/GetStudyUnitStudyMaterialCountReport',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetStudyUnitReport(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any[]>(
        this.url + 'api/GetSubjectAndStudyUnitReport',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetTopicsList(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<any>(this.url + 'api/GetTopics', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  InsertOrUpdateRating(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    data.ErrorMessage = '';
    return this.http.post(
      `${this.url}/api/InsertOrUpdateStudyMaterialTopicCoverageRating/`,
      data
    );
  }

  GetStudyMaterialRating(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http.post(
      `${this.url}/api/GetStudyMaterialTopicCoverageRating/`,
      data
    );
  }

  GetStudyMaterialApplicableCoursePlan(
    userId: string,
    studyMaterialId: number | null,
    CourseID: number | null = null,
    CoursePlanID: number | null = null,
    SelectedInd: string | null = 'Y',
    ScreenName: string = 'ASSIGN_STUDY_MATERIAL_TO_COURSE_PLAN',
    StudyUnitID: number | null = null,
    SessionLanguageTypeCode: string = this.appserv.userlanuage
  ) {
    return this.http.post(
      `${this.url}/api/GetStudyMaterialApplicableCoursePlan`,
      {
        StudyMaterialId: studyMaterialId,
        LoggedInUserID: userId,
        ScreenName: 'ASSIGN_STUDY_MATERIAL_TO_COURSE_PLAN',
        CourseID: CourseID,
        CoursePlanID: CoursePlanID,
        SelectedInd: SelectedInd,
        StudyUnitID: StudyUnitID,
        SessionLanguageTypeCode: SessionLanguageTypeCode,
      }
    );
  }

  getStudyMaterialApplicableCourseCategory(
    userId: string,
    studyMaterialId: number | null,
    SelectedInd: string | null = 'Y',
    ScreenName: string = 'ASSIGN_STUDY_MATERIAL_TO_COURSE_PLAN',
    StudyUnitID?: number | null
  ) {
    return this.http.post(
      `${this.url}/api/GetStudyMaterialApplicableCourseCategory`,
      {
        StudyMaterialId: studyMaterialId,
        LoggedInUserID: userId,
        SelectedInd,
        ScreenName,
        StudyUnitID: StudyUnitID ?? null,
      }
    );
  }

  InsertOrUpdateStudyMaterialApplicableCoursePlan$(formdata: any) {
    return this.http.post(
      this.url + 'api/InsertOrUpdateStudyMaterialApplicableCoursePlan',
      formdata
    );
  }
}
